<template>
  <div class="donation-bankid">
    <div class="donation-bankid__content">
      <span @click="close" class="donation-bankid__close"></span>
      <img class="donation-bankid__image" src="../assets/bankid.png" />
      <div class="donation-bankid__header">
        {{ header }}
      </div>
      <div class="donation-bankid__text">
        {{ text }}
      </div>
      <div v-if="qr" class="donation-bankaccount__qr">
        <img :src="qr" />
      </div>
      <div class="donation-bankid__buttons">
        <button
          @click.prevent="proceedSameDevice"
          class="donation-bankid__button-1"
        >
          {{ windowWidth > 800 ? sameDevice : sameDeviceMobile }}
        </button>
      </div>
      <div v-if="showMessage" class="donation-bankid__message">
        {{ message }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BankId',

  props: {
    header: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
    sameDevice: {
      type: String,
      required: true,
    },
    anotherDevice: {
      type: String,
      required: true,
    },
    sameDeviceMobile: {
      type: String,
      required: true,
    },
    anotherDeviceMobile: {
      type: String,
      required: true,
    },
    message: {
      type: String,
      default: null,
    },
    showMessage: {
      type: Boolean,
      default: false,
    },
    qr: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      windowWidth: window.innerWidth,
    };
  },

  methods: {
    close() {
      this.$emit('close');
    },

    proceedSameDevice() {
      this.$emit('proceedSameDevice');
    },
  },
};
</script>

<style lang="scss">
.donation-bankid {
  position: fixed;
  height: 100%;
  bottom: 0;
  right: 0;
  left: 0;
  top: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9999999;

  @media screen and (max-width: 800px) {
    max-width: 100vw;
  }
  &__content {
    background-color: #fff;
    margin: 80px auto;
    position: relative;
    width: 90%;
    width: 340px;
    padding: 16px 16px 26px 16px;
    border-radius: 8px;
  }
  &__close {
    color: #000;
    position: absolute;
    top: 5px;
    right: 9px;
    font-size: 28px;
    cursor: pointer;
    background-image: url('../assets/close-modal.svg');
    width: 27px;
    height: 28px;
    cursor: pointer;
  }
  &__image {
    margin-left: auto;
    margin-right: auto;
    width: 92px;
    height: auto;
  }
  &__header {
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: bold;
    font-size: 22px;
    line-height: 30px;
    text-align: center;
    padding: 8px 0px;
  }
  &__text,
  &__message {
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: normal;
    font-size: 15px;
    line-height: 20px;
    text-align: center;
    padding: 8px 0px;
  }
  &__buttons {
    margin: 23px 0 0 0;
    flex-direction: column-reverse;
    display: flex;

    @media screen and (max-width: 800px) {
      flex-direction: column;
    }
  }
  &__button {
    &-1 {
      display: flex;
      justify-content: center;
      width: 100%;
      background: #fff;
      box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.04);
      border-radius: 4px;
      border: none;
      padding: 16px 14px;
      color: #006c81;
      border: 2px solid #006c81;
      font-family: 'Open Sans';
      font-style: normal;
      font-weight: bold;
      font-size: 15px;
      line-height: 25px;
      cursor: pointer;
      position: relative;
      width: 100%;

      @media screen and (max-width: 800px) {
        white-space: nowrap;
        width: 100%;
        font-size: 14px;
        padding: 8px 16px;
        margin-bottom: 15px;
        color: #fff;
        background: #006c81;
      }

      &:disabled {
        &::before {
          content: '';
          position: absolute;
          background-image: url('../assets/spinner.svg');
          background-repeat: no-repeat;
          background-size: cover;
          width: 26px;
          height: 26px;
          left: 142px;
          top: -105px;

          @media screen and (max-width: 800px) {
            top: -28px;
          }
        }
      }
    }
    &-2 {
      display: flex;
      justify-content: center;
      font-family: 'Open Sans';
      font-style: normal;
      font-weight: bold;
      font-size: 15px;
      line-height: 22px;
      text-decoration: none;
      cursor: pointer;
      border: 2px solid #006c81;
      box-sizing: border-box;
      border-radius: 4px;
      padding: 16px 14px;
      margin-bottom: 15px;
      background: #006c81;
      color: #fff !important;

      @media screen and (max-width: 800px) {
        white-space: nowrap;
        width: 100% !important;
        font-size: 14px;
        padding: 8px 16px;
        margin-bottom: 0;
        color: #006c81 !important;
        background: #fff;
      }
    }
  }
}
</style>
